import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { FinancialEcomsyncItemSyncingHistoryContainerModel } from '../../../../../../models/aggregates/erp/financial';
import { Core2Config } from '../../shared/core2Config';

@Injectable({
  providedIn: 'root'
})
export class FinancialEcomsyncItemSyncingHistoryService extends BaseApiTemplateService<FinancialEcomsyncItemSyncingHistoryContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.FI_PREFIX + 'item-syncing-history';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.FI_PREFIX + 'item-syncing-history';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ECOMSYNC_PREFIX + Core2Config.FI_PREFIX + 'item-syncing-history';
    this.httpClient = http;
  }

}
